/**
 *  NAV
 */
const UNIFIED_NAV_MOUNTED = 'unified-nav-mounted';

// eslint-disable-next-line import/prefer-default-export
export { UNIFIED_NAV_MOUNTED };
